import axios from "axios";

export const getAllRequest = () => axios.get(`/addresses/provinces`)
